import React from 'react';

import { useTheme } from 'styled-components';
import { ThemeType } from 'theme/theme';

import { ReactComponent as BackpackActive } from 'assets/images/luggages/backpack-active.svg';
import { ReactComponent as HandLuggageActive } from 'assets/images/luggages/hand-luggage-active.svg';
import { ReactComponent as HandLuggage } from 'assets/images/luggages/hand-luggage.svg';
import { ReactComponent as WarehouseLuggageActive } from 'assets/images/luggages/warehouse-luggage-active.svg';
import { ReactComponent as WarehouseLuggage } from 'assets/images/luggages/warehouse-luggage.svg';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Container, Title, Luggage, Division, Restrictions, IconContainer } from './styles';

interface Props {
  restrictions?: string;
  handBaggage?: boolean;
}

const FlightSectorBaggage = ({ restrictions, handBaggage }: Props) => {
  const { t } = useStoreTranslation();

  const haveWarehouseBaggage = !restrictions?.startsWith('0');
  const theme = useTheme() as ThemeType;

  return (
    <Container>
      <Title>{t('flightSectorBaggage.title')}</Title>

      <Luggage className="include">
        <IconContainer>
          <BackpackActive fill={theme.primaryBackgroundColor} stroke={theme.primaryBackgroundColor} />
        </IconContainer>
        {t('flightSectorBaggage.includedPersonalBaggage')}
      </Luggage>

      <Division />

      <Luggage className={handBaggage ? 'include' : ''}>
        <IconContainer>
          {handBaggage ? (
            <HandLuggageActive fill={theme.primaryBackgroundColor} stroke={theme.primaryBackgroundColor} />
          ) : (
            <HandLuggage />
          )}
        </IconContainer>
        {t(handBaggage ? 'flightSectorBaggage.includedHandBaggage' : 'flightSectorBaggage.notIncludedHandBaggage')}
      </Luggage>

      <Division />

      <Luggage className={haveWarehouseBaggage ? 'include' : ''}>
        <IconContainer>
          {haveWarehouseBaggage ? (
            <WarehouseLuggageActive fill={theme.primaryBackgroundColor} stroke={theme.primaryBackgroundColor} />
          ) : (
            <WarehouseLuggage />
          )}
        </IconContainer>
        {t(
          haveWarehouseBaggage
            ? 'flightSectorBaggage.includedWarehouseBaggage'
            : 'flightSectorBaggage.notIncludedWarehouseBaggage',
        )}
      </Luggage>

      <Restrictions>
        {t(haveWarehouseBaggage ? 'flightSectorBaggage.restriction' : 'flightSectorBaggage.buyWarehouseBaggage', {
          restrictions,
        })}
      </Restrictions>
    </Container>
  );
};

export default FlightSectorBaggage;
